import { Repository } from 'rest-adapter';
import { TypeInterface } from '../Enum/Groups';
import { Product } from '../Model/Product';
import { ServiceLocator } from '../ServiceLocator';
import { TypeUtility } from './TypeUtility';

export class RepositoryFactory {
    constructor(private readonly serviceLocator: ServiceLocator) {}

    public build(type: TypeInterface): Repository<Product> {
        return new Repository(
            Product,
            TypeUtility.getResourceTypeForType(type, this.serviceLocator.get('config')),
            this.serviceLocator.get('adapter')
        );
    }
}
